import { render, staticRenderFns } from "./repost.vue?vue&type=template&id=2142af1d"
import script from "./repost.vue?vue&type=script&lang=js"
export * from "./repost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports